import { render, staticRenderFns } from "./LoyaltyChipSelector.vue?vue&type=template&id=1ba025c6&scoped=true&"
import script from "./LoyaltyChipSelector.vue?vue&type=script&lang=js&"
export * from "./LoyaltyChipSelector.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyChipSelector.vue?vue&type=style&index=0&id=1ba025c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba025c6",
  null
  
)

export default component.exports